import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import { CircularProgress } from "@material-ui/core";
import { PursuitDialogWrapper } from "../Pursuit.style";
import CancelIcon from "@material-ui/icons/Cancel";
import { Api, URL_ECONOMIC_DASHBOARD } from "Helpers";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";

const TYPE = {
	HOW_TO_PLAY: "howToPlay",
	DID_YOU_KNOW: "didYouKnow",
};

const DEFAULT_TYPE = TYPE.DID_YOU_KNOW;
const NEXT_TYPE = TYPE.HOW_TO_PLAY;

const HowToPlay = (props) => {
	const [content, setContent] = useState(""),
		[type, setType] = useState(DEFAULT_TYPE),
		[isLoading, setLoading] = useState(false),
		[pdfLoader, setPdfLoader] = useState(false);

	const navigate = useNavigate();
	// eslint-disable-next-line
	useEffect(() => {
		fetchData();
	}, []);

	async function fetchData() {
		setLoading(true);
		let data = new FormData();
		data.append("moduleId", props.data.id);
		data.append("subjectId", props?.subjectId);
		let response = await new Api().post("staticPage/game", { data });
		setContent(response.data);
		setLoading(false);
	}

	function proceed() {
		if (type === DEFAULT_TYPE) setType(NEXT_TYPE);
		else {
			closeModal();
		}
	}

	function closeModal() {
		if (props.data.url) {
			handleClose();

			let data = props?.pursuitDetails;

			if (props?.sidebar && props.sidebar) data = { subjectId: props?.subjectId };

			navigate(URL_ECONOMIC_DASHBOARD + "/" + props.data.url, { state: { data } });
		} else {
			handleClose();
		}
	}

	function handleClose() {
		props.handleClose({ url: props.data.url });
	}

	const handlePdf = () => {
		setPdfLoader(true);
		let pdfUrl,
			attachedText = "",
			moduleName = props?.data?.id.replace(/ /g, "_").toUpperCase();
		if (type === TYPE.DID_YOU_KNOW) {
			pdfUrl = content?.didYouKnowFile;
			attachedText = `${moduleName}_DID_YOU_KNOW`;
		} else {
			pdfUrl = content?.howToPlayFile;
			attachedText = `${moduleName}_HOW_TO_PLAY`;
		}

		fetch(pdfUrl).then((response) => {
			response.blob().then((blob) => {
				// Creating new object of PDF file
				const fileURL = window.URL.createObjectURL(blob);
				// Setting various property values
				let alink = document.createElement("a");
				alink.href = fileURL;
				alink.download = `${attachedText}.pdf`;
				alink.click();
				setPdfLoader(false);
			});
		});
	};

	const ThumbVertical = (props) => <div {...props} className="thumb-vertical" />;

	return (
		<PursuitDialogWrapper
			onClose={handleClose}
			open={props.open}
			PaperProps={{ elevation: 0 }}
			classes={{ paper: "dialog-paper", paperWidthSm: "paper" }}
			BackdropProps={{
				classes: {
					root: "backdrop",
				},
			}}
		>
			<div className="box-modal text-center">
				<div className="title-container">
					<p className="sub-title white-color">{type === TYPE.HOW_TO_PLAY ? "How to play ?" : "Did you know ?"}</p>
					{/* <div className="icon-container" onClick={handleClose}>
						<CancelIcon className="icon" />
					</div> */}
				</div>
				<div className="content-wrapper">
					{isLoading && (
						<div className="progress">
							<CircularProgress size={25} />
						</div>
					)}
					<Scrollbars className={"scroll-bar"} renderThumbVertical={ThumbVertical}>
						<div className="content" dangerouslySetInnerHTML={{ __html: content[type] }} />
						{content?.didYouKnowFile && type === TYPE.DID_YOU_KNOW && (
							<div className="attach-file">
								<PictureAsPdfIcon className="icon" />
								<div className="file" onClick={handlePdf}>
									Attachment
								</div>
								{pdfLoader && (
									<div>
										<CircularProgress className="pdf-loader" />
									</div>
								)}
							</div>
						)}

						{content?.howToPlayFile && type === TYPE.HOW_TO_PLAY && (
							<div className="attach-file">
								<PictureAsPdfIcon className="icon" />
								<div className="file" onClick={handlePdf}>
									Attachment
								</div>
								{pdfLoader && (
									<div>
										<CircularProgress className="pdf-loader" />
									</div>
								)}
							</div>
						)}
					</Scrollbars>
					{
						<div className={`type-switcher ${type === DEFAULT_TYPE ? "visibility-none" : ""}`}>
							<div className="divider" />
							{type === TYPE.HOW_TO_PLAY && (
								<p
									className="text"
									onClick={() => {
										setType(TYPE.DID_YOU_KNOW);
									}}
								>
									Back to Review
								</p>
							)}
						</div>
					}
					<div className={`play ${type === DEFAULT_TYPE ? "how-to-play" : "lets-play"}`} onClick={proceed}>
						{" "}
						{type === DEFAULT_TYPE ? "How to Play" : "Lets Play"}
					</div>
				</div>
			</div>
		</PursuitDialogWrapper>
	);
};

export default HowToPlay;
